import React, { useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { openDialog } from "../../../../store/actions";

interface IProps {
  type: string;
  disabled?: boolean;
}

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions))
})

const connector = connect(null, mapDispatchToProps);

const EmptySlot = ({
  type,
  disabled,
  openDialogDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const sellItemButtonRef = useRef(null)

  return (
    <>
      <span className="white">Available slot</span>
      <i className="icon icon-standalone icon-sm icon-zlato blank middle"/>
      <div>
        <a href="#"
           ref={sellItemButtonRef}
           onClick={() => !disabled && openDialogDispatch({
             name: "SellItem",
             header: "Sell item",
             elementRef: sellItemButtonRef.current,
             type
           })}
        >
          <i className="icon icon-plus icon-lg middle white"/>
        </a>
      </div>
    </>
  )
}

export default connector(EmptySlot);
